
export default {
  data() {
    return {};
  },
  head() {
    const WEB_SITE_URL = this.$config.WEB_SITE_URL;
    const routePath = this.$route.path;

    const languages = [
      "ar",
      "bg",
      "hr",
      "cs",
      "da",
      "nl",
      "fi",
      "fr",
      "de",
      "el",
      "hi",
      "it",
      "ja",
      "ko",
      "no",
      "pl",
      "pt",
      "ro",
      "ru",
      "es",
      "sv",
      "ca",
      "tl",
      "iw",
      "id",
      "lv",
      "lt",
      "sr",
      "sk",
      "sl",
      "uk",
      "vi",
      "sq",
      "et",
      "gl",
      "hu",
      "mt",
      "th",
      "tr",
      "fa",
      "af",
      "ms",
      "sw",
      "ga",
      "cy",
      "be",
      "is",
      "mk",
      "yi",
      "hy",
      "az",
      "eu",
      "ka",
      "ht",
      "ur",
      "bn",
      "bs",
      "ceb",
      "gu",
      "ha",
      "hmn",
      "ig",
      "jw",
      "kn",
      "km",
      "lo",
      "mi",
      "mr",
      "mn",
      "ne",
      "pa",
      "so",
      "ta",
      "te",
      "yo",
      "zu",
      "my",
      "ny",
      "kk",
      "mg",
      "ml",
      "si",
      "st",
      "su",
      "tg",
      "uz",
      "am",
      "co",
      "haw",
      "ku",
      "ky",
      "lb",
      "ps",
      "sm",
      "gd",
      "sn",
      "sd",
      "fy",
      "eo",
      "xh",
      "la",
      "en",
    ];

    const langLinks = languages.map(language => ({
      rel: "alternate",
      hreflang: language,
      href:
        language === "en"
          ? `${WEB_SITE_URL}${routePath}`
          : `${WEB_SITE_URL}${routePath}`.replace(/\bwww\./, `${language}\.`),
    }));

    let bannerUrl = [];
    if (this.$route.path == "/") {
      bannerUrl = this.$store.state.bannerList.map(v => ({
        fetchpriority: "high",
        rel: "preload",
        href: v.url,
        as: "image",
      }));
    }

    return {
      title: this.$route.meta?.title,
      htmlAttrs: {
        style: "overflow-x:hidden",
      },
      meta: [
        {
          charset: "UTF-8",
        },
        {
          hid: "description",
          name: "description",
          content: this.$route.meta?.description,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.$route.meta?.keywords,
        },
        {
          property: "og:url",
          content: `${WEB_SITE_URL}${routePath}`,
        },
        {
          property: "og:title",
          content: this.$route.meta?.title,
        },
        {
          property: "og:description",
          content: this.$route.meta?.description,
        },
      ],
      link: [
        { rel: "icon", type: "image/x-icon", href: this.$store.state.favicon },
        { rel: "canonical", href: `${WEB_SITE_URL}${routePath}` },
        ...langLinks,
        ...bannerUrl,
      ],
      script: [{ src: "/js/index.js", defer: true }],
    };
  },
};
